import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c36dac12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  colspan: "2",
  style: {"text-align":"center","font-weight":"bold"}
}



export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentMethodDefault',
  props: {
    wireForm: {},
    phonesData: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.$t("fields.paymentMethod")), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.method")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.payment.paymentServiceName), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.countryOfBank")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.phonesData[_ctx.wireForm.bankInfo.bankCountry.toLowerCase()].name), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.bankName")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.bankName), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.branchName")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.branchName), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.city")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.city), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.state")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.state), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.accountHolder")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.holder), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.accountNo), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.confirmAccountNo")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.confirmAccountNo), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.bsb")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.bsb), 1)
    ]),
    _createElementVNode("tr", null, [
      _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.swiftCode")), 1),
      _createElementVNode("td", null, _toDisplayString(_ctx.wireForm.bankInfo.swiftCode), 1)
    ])
  ]))
}
}

})